export default "__VITE_ASSET__CxER1Kh___"